<template lang="pug">
  box
    page-title(slot="page-title", title="Ouvidoria - Nova ocorrência")
    .container.grid-lg.height-100(slot="content")
      .bg-gray.p-2.mt-2.s-rounded
        steps.pt-2(:steps="steps" :step-style="{ fontSize: '.55rem' }")
      router-view.height-100(:key="$route.name")
</template>

<script>
export default {
  data() {
    return {
      steps: [
        { routeName: 'app.ouvidoria.create.categoria', title: 'Categoria' },
        { routeName: 'app.ouvidoria.create.fotos', title: 'Fotos' },
        { routeName: 'app.ouvidoria.create.local', title: 'Local' },
        { routeName: 'app.ouvidoria.create.descricao', title: 'Descrição' },
        { routeName: 'app.ouvidoria.create.confirmar', title: 'Confirmar' },
      ]
    }
  }
}
</script>
